import { useParams } from 'react-router-dom';

import { useGetCase } from '@/api/queries/useGetCase';
import { useGetDoc } from '@/api/queries/useGetDoc';
import { Breadcrumb } from '@/new/components/breadcrumb';
import { LargeDocViewer } from '@/new/components/doc-viewer/large-doc-viewer';

export function Document() {
  const { matterId, subsetId, docId } = useParams();
  if (!matterId || !subsetId || !docId) return;

  const { data: caseData } = useGetCase(matterId);
  const { data: doc } = useGetDoc(matterId, docId);

  return (
    <div className="flex h-full flex-col">
      <Breadcrumb
        items={
          caseData
            ? [
                { href: '/matters', label: 'Matters', active: false },
                { href: `/matters/${matterId}/subsets`, label: caseData.name, active: false },
                { href: `/matters/${matterId}/subsets/${subsetId}/docs`, label: 'Documents', active: true },
                {
                  href: `/matters/${matterId}/subsets/${subsetId}/docs/${docId}`,
                  label: doc?.file.name ?? '',
                  active: true,
                },
              ]
            : [{ href: '/matters', label: 'Matters', active: false }]
        }
      />

      <div className="flex-1 overflow-hidden px-8 text-sm">
        <LargeDocViewer docId={docId} caseId={matterId} />
      </div>
    </div>
  );
}
